module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-05-fa8700dd416ed0739e56a336be2a3555.jpg";